import { openBlock as e, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ c("path", { d: "M15.75 7.995c0-4.27-3.48-7.75-7.75-7.75S.25 3.725.25 7.995c0 1.56.46 3.05 1.32 4.33l-.78 2.1c-.09.25-.05.53.12.74.17.21.43.31.7.26l2.93-.48c1.07.53 2.25.81 3.45.81 4.27 0 7.75-3.48 7.75-7.75l.01-.01Zm-7.33.65v.23H7.26v-.24c-.07-.7.17-1.09.78-1.45.56-.34.73-.55.73-.95 0-.4-.33-.69-.83-.69-.5 0-.83.31-.86.79H5.9c.02-1.09.78-1.84 2.12-1.84 1.25 0 2.08.69 2.08 1.7 0 .66-.32 1.11-.94 1.48-.58.34-.74.55-.74.97Zm.28 2.29c0 .46-.38.84-.84.84-.46 0-.84-.38-.84-.84 0-.46.38-.84.84-.84.46 0 .84.38.84.84Z" }, null, -1), r = [
  n
];
function l(s, d) {
  return e(), t("svg", o, [...r]);
}
const _ = { render: l };
export {
  _ as default,
  l as render
};
